import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { format, parseISO } from 'date-fns'
import { Receipt } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'

const BillDetailsModal = ({ isOpen, onClose, isYardi, data }) => {
  const { t } = useTranslation(['organisation'])
  if (!isOpen) return null

  return (
    <ModalContainer
      isVisible={isOpen}
      onClose={onClose}
      additionalClass="bill-details-modal"
      headerTitle={t('organisation:payments.billDetails.headerTitle')}
      headerIcon={<Receipt size={24} />}
    >
      {isYardi ? (
        <Fragment>
          <div className="flex-row">
            <div className="details-item">{t('organisation:payments.billDetails.billTitle')}</div>
            <div className="details-item short">{data.comment}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">{t('organisation:payments.billDetails.dueDate')}</div>
            <div className="details-item">{format(new Date(data.transactionDate), 'MMMM, do')}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">{t('organisation:payments.billDetails.balanceDue')}</div>
            <div className="details-item">${data.balanceDue}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">
              {t('organisation:payments.billDetails.billingNumber')}
            </div>
            <div className="details-item">{data.billingNumber}</div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="flex-row">
            <div className="details-item">{t('organisation:payments.billDetails.billTitle')}</div>
            <div className="details-item short">{data.webDescription}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">{t('organisation:payments.billDetails.billingType')}</div>
            <div className="details-item">{data.AcctSeed__Type__c}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">
              {t('organisation:payments.billDetails.billingNumber')}
            </div>
            <div className="details-item">{data.Name}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">{t('organisation:payments.billDetails.unitDetails')}</div>
            <div className="details-item">{data.Rentable__c}</div>
          </div>
          <div className="flex-row">
            <div className="details-item">
              {t('organisation:payments.billDetails.billingSubtype')}
            </div>
            <div className="details-item">{data.Type__c}</div>
          </div>
          {data.AcctSeed__Billing_Cycle_Start_Date__c &&
            data.AcctSeed__Billing_Cycle_End_Date__c && (
              <div className="flex-row">
                <div className="details-item">
                  {t('organisation:payments.billDetails.billingCycle')}
                </div>
                <div className="details-item">
                  {format(parseISO(data.AcctSeed__Billing_Cycle_Start_Date__c), 'MM/dd/yyyy')} -{' '}
                  {format(parseISO(data.AcctSeed__Billing_Cycle_End_Date__c), 'MM/dd/yyyy')}
                </div>
              </div>
            )}
          <div className="flex-row">
            <div className="details-item">
              {t('organisation:payments.billDetails.totalBalance')}
            </div>
            <div className="details-item">${data.AcctSeed__Balance__c.toFixed(2)}</div>
          </div>
        </Fragment>
      )}
    </ModalContainer>
  )
}

BillDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isYardi: PropTypes.bool,
  data: PropTypes.object,
}

export default BillDetailsModal
